module.exports = __webpack_public_path__ + "img/patients-main-phone.8bb8dfcf.png";